import { useState } from 'react'
import { toast } from 'react-toastify'
import { useClient } from 'urql'

import { SurveyForm, type TSurveyResponse } from '@/components/survey-form'
import { graphql } from '@/gql'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  onOk: () => void
}

export const MembershipQuestionnaireModal = ({
  isOpen,
  onOk,
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  const client = useClient()
  const [isLoading, setIsLoading] = useState(false)

  const handleFormSubmit = async ({
    surveyId,
    responses,
  }: {
    surveyId: string
    responses: TSurveyResponse[]
  }) => {
    if (isLoading) return

    setIsLoading(true)
    try {
      const result = await client
        .mutation(CompleteMembershipQuestionnaireMutation, {})
        .toPromise()

      await client.mutation(
        MembershipQuestionnaire_CreateSurveyResponseMutation,
        {
          input: {
            surveyId,
            responseableInput: {
              belongsToUser: true,
            },
            surveyResponseAnswers: responses,
          },
        }
      )

      if (!result.error || !result.data?.tutorialComplete?.errors) {
        toast.success('アンケートを送信しました', {
          toastId: 'create-survey-response-succeed',
          position: 'bottom-right',
        })
      }
      onOk()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          backgroundColor: '#F5F7FC',
          padding: 0,
          maxWidth: '720px',
          width: '100%',
          maxHeight: '100%',
          borderRadius: 18,
          overscrollBehaviorY: 'contain',
        },
      }}
      showCloseButton={false}
      {...rest}
    >
      <div className="p-5 md:p-12">
        <SurveyForm
          surveyName="membership_questionnaire"
          choiceStyle="pill"
          onSubmit={handleFormSubmit}
          submitText="回答する"
          disabled={isLoading}
        />
      </div>
    </Modal>
  )
}

const CompleteMembershipQuestionnaireMutation = graphql(`
  mutation CompleteMembershipQuestionnaireMutation {
    tutorialComplete(input: { kind: MEMBERSHIP_QUESTIONNAIRE }) {
      viewer {
        id
        notCompletedTutorials {
          kind
        }
      }
      errors {
        __typename
      }
    }
  }
`)

const MembershipQuestionnaire_CreateSurveyResponseMutation = graphql(`
  mutation MembershipQuestionnaire_CreateSurveyResponseMutation(
    $input: SurveyResponseCreateInput!
  ) {
    surveyResponseCreate(input: $input) {
      errors {
        ... on ValidationError {
          field
          message
        }
      }
    }
  }
`)
